
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"3.5 3.5 29 29"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 14.932v10.432m.614-14.728a.614.614 0 11-1.228 0 .614.614 0 011.228 0zM31.5 18c0 7.456-6.044 13.5-13.5 13.5S4.5 25.456 4.5 18 10.544 4.5 18 4.5 31.5 10.544 31.5 18z","stroke":"#475668","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    